import { createFileRoute, redirect } from '@tanstack/react-router'

// The customer display moved under the POS namespace at /sale/display. Keep this
// path as a permanent redirect so bookmarks and already-open buyer-facing tablets
// (which may sit on /customer-display for a whole shift) follow to the new URL.
export const Route = createFileRoute('/_app/_authed/customer-display')({
    beforeLoad: () => {
        throw redirect({ to: '/sale/display' })
    },
})
